/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Calculation_TitleInputs */

const en_matching_score_calculation_title = /** @type {(inputs: Matching_Score_Calculation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating matching score`)
};

const de_matching_score_calculation_title = /** @type {(inputs: Matching_Score_Calculation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnung Matching-Score`)
};

/**
* | output |
* | --- |
* | "Calculating matching score" |
*
* @param {Matching_Score_Calculation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_calculation_title = /** @type {((inputs?: Matching_Score_Calculation_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Calculation_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_calculation_title(inputs)
	return en_matching_score_calculation_title(inputs)
});